import { render, staticRenderFns } from "./posLoss.vue?vue&type=template&id=f7cbb08c&scoped=true&"
import script from "./posLoss.vue?vue&type=script&lang=js&"
export * from "./posLoss.vue?vue&type=script&lang=js&"
import style0 from "./posLoss.vue?vue&type=style&index=0&id=f7cbb08c&prod&scoped=true&lang=css&"
import style1 from "./posLoss.vue?vue&type=style&index=1&id=f7cbb08c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7cbb08c",
  null
  
)

export default component.exports